import React from 'react';
import SortableItem from './sortableItem';
import { SortableContainer } from 'react-sortable-hoc';
import './sortableItem';

const SortableList = (props) => {
  return (
    <ul>
      {props.items.map((value, index) => (
       <SortableItem key={`item-${index}`} index={index} value={value} ind={index}  checkGraph={props.checkGraph}/>
      ))}
    </ul>
  );
};

export default SortableContainer(SortableList);